import { NotificacionesRestService } from './notificaciones-rest.service';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./notificaciones-rest.service";
/**
 * Data service que almacena número de notificaciones pendientes de leer,
 * lo que permite actualizar este número en la cabecera.
 */
var NotificacionesDataService = /** @class */ (function () {
    function NotificacionesDataService(notificacionesRestService) {
        this.notificacionesRestService = notificacionesRestService;
        this._numNotificacionesPorLeer = new BehaviorSubject(0);
    }
    Object.defineProperty(NotificacionesDataService.prototype, "numeroNotificacionesPorLeer", {
        get: function () {
            return this._numNotificacionesPorLeer.getValue();
        },
        set: function (numeroPorLeer) {
            this._numNotificacionesPorLeer.next(numeroPorLeer);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificacionesDataService.prototype, "numeroNotificacionesPorLeerObservable", {
        get: function () {
            return this._numNotificacionesPorLeer.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    NotificacionesDataService.prototype.actualizarNotificacionesPorLeer = function () {
        var _this = this;
        this.notificacionesRestService.contarNotificacionesNoLeidas()
            .pipe(take(1)).subscribe(function (notificaciones) {
            _this._numNotificacionesPorLeer.next(notificaciones);
        });
    };
    NotificacionesDataService.ngInjectableDef = i0.defineInjectable({ factory: function NotificacionesDataService_Factory() { return new NotificacionesDataService(i0.inject(i1.NotificacionesRestService)); }, token: NotificacionesDataService, providedIn: "root" });
    return NotificacionesDataService;
}());
export { NotificacionesDataService };
